import state from './note.state'
import mutations from './note.mutations'
import actions from './note.actions'

export default {
  state,
  mutations,
  actions
}
